import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {User} from '../../../graphql/auth';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';

interface DeleteUserVars {
    id: number;
}

interface DeleteUserData {
    deleteUser: User
}

export const DELETE_USER_MUTATION = gql`
    mutation deleteUser($id: Int!) {
        deleteUser(id: $id) {
          id
          email
        }
    }
`;

export const deleteUser = () => useMutation<DeleteUserData, DeleteUserVars>(
    DELETE_USER_MUTATION,
    {
        update: updateCacheByType('User'),
    }
);

export default deleteUser;